export default __webpack_public_path__ + "static/logo-985843bef19101417f6b036614337e3b.svg";